module.exports = __webpack_public_path__ + "static/preview-6f78f9ec85ed175f4b00aafd6e97ff11.jpg";